import _request from '@/utils/request.js'

var _template = {
    // 查询所有可用主模板
    getMainTemplateAll (storedType, resolve, reject) {
        _request.api({
            url     : _request.getCardsUrl("/main/template/listInfo"),
            params  : {
                storedType: storedType
            },
            method  : 'get',
            success : resolve,
            error   : reject
        })
    },
    // 根据主模板查询子模板
    getTemplateAll (parentId, resolve, reject) {
        _request.api({
            url     : _request.getCardsUrl("/api/cardstemplate/getTemplateListByPid"),
            params    : {
                pid: parentId
            },
            method  : 'get',
            success : resolve,
            error   : reject
        })
    },
    // 根据父模板归属人查询子模板
    getTemplateListByOwnerUser (parentId, isOwner, resolve, reject) {
        _request.api({
            url     : _request.getCardsUrl("/api/cardstemplate/getTemplateListByOwnerUser"),
            params    : {
                pid: parentId,
                isOwner: isOwner ? 1 : 2
            },
            method  : 'get',
            success : resolve,
            error   : reject
        })
    }
}

export default _template